<template>
  <transition name="fade">
    <div v-if="show" class="language-overlay">
      <div class="language-wrapper">
        <!-- Header -->
        <div class="language-header">
          <h2 class="language-title">{{ $t("sidebar.language") }}</h2>
          <button class="close-btn" @click="close" aria-label="Close modal">
            ✕
          </button>
        </div>

        <!-- Body -->
        <div class="language-grid">
          <div
            v-for="lang in languages"
            :key="lang.code"
            class="language-card"
            :class="{ active: currentLang === lang.code }"
            @click="selectLanguage(lang.code)"
          >
            <img :src="lang.flag" :alt="`${lang.name} flag`" class="flag-icon" />
            <span class="language-name">{{ lang.name }}</span>
            <div v-if="currentLang === lang.code" class="check-badge">✓</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import i18n from "@/locales/i18n";

export default {
  name: "LanguageModal",
  props: {
    show: { type: Boolean, default: false }
  },
  data() {
    return {
      languages: [
        { code: "en", name: "English", flag: require("@/assets/img/flags/en.svg") },
        { code: "tr", name: "Türkçe", flag: require("@/assets/img/flags/tr.svg") },
        { code: "de", name: "Deutsch", flag: require("@/assets/img/flags/de.svg") },
        { code: "pt", name: "Português", flag: require("@/assets/img/flags/pt.svg") },
        { code: "fr", name: "Français", flag: require("@/assets/img/flags/fr.svg") },
        { code: "it", name: "Italiano", flag: require("@/assets/img/flags/it.svg") },
        { code: "zh", name: "中文", flag: require("@/assets/img/flags/china.svg") },
        { code: "hi", name: "हिन्दी", flag: require("@/assets/img/flags/hint.png") },
        { code: "ru", name: "Русский", flag: require("@/assets/img/flags/ru.svg") },
        { code: "id", name: "Bahasa Indonesia", flag: require("@/assets/img/flags/id.svg") },
     
        { code: "fil", name: "Filipino", flag: require("@/assets/img/flags/ph.svg") }
      ]
    };
  },
  computed: {
    currentLang() {
      return i18n.global.locale.value;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    selectLanguage(code) {
      i18n.global.locale.value = code;
      localStorage.setItem("language", code);
      this.close();
    }
  }
};
</script>

<style scoped>
/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Fullscreen overlay */
.language-overlay {
  position: fixed;
  inset: 0;
  background: #1f363688;
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 60px 20px;
  z-index: 20000;
  overflow-y: auto;
}

/* Wrapper */
.language-wrapper {
  width: 100%;
  max-width: 1000px;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 40px;
  animation: fadeInUp 0.4s ease;
}

/* Header */
.language-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.language-title {
  font-size: 28px;
  font-weight: 800;
  background: linear-gradient(90deg, #ffde59, #ffa033);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.close-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #fff;
  font-size: 22px;
  padding: 8px 14px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.25s ease;
}
.close-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: rotate(90deg);
}

/* Grid */
.language-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 24px;
}

/* Card */
.language-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 20px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  border: 1px solid transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.language-card:hover {
  transform: translateY(-6px) scale(1.03);
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.3);
}
.language-card.active {
  border: 2px solid #ffde59;
  background: rgba(255, 222, 89, 0.12);
  box-shadow: 0 0 18px rgba(255, 222, 89, 0.6);
}

/* Check badge */
.check-badge {
  position: absolute;
  top: 10px;
  right: 12px;
  font-size: 18px;
  font-weight: bold;
  color: #ffde59;
}

/* Flag */
.flag-icon {
  width: 48px;
  height: 34px;
  border-radius: 6px;
  object-fit: cover;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}

/* Text */
.language-name {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.4px;
}

/* Animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(25px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
